import { Theme, createStyles, makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    helperText: {
      position: "absolute",
      bottom: "-22px",
    },
    textField: {
      position: "relative",
      marginBottom: 12,
    },
  }),
);
